import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Save, Zap, PhoneOff } from "lucide-react";
import { toast } from "sonner";

export default function Settings() {
  const { tenant, setTenant, user } = useAuth();
  const [proc, setProc] = useState(5);
  const [avg, setAvg] = useState(3);

  useEffect(() => {
    if (tenant) {
      setAvg(tenant.avg_call_duration_min || 3);
      setProc(tenant.avg_quote_processing_min || 5);
    }
  }, [tenant]);

  async function save() {
    const r = await api.put("/tenant/settings", {
      avg_call_duration_min: Number(avg),
      avg_quote_processing_min: Number(proc),
    });
    setTenant(r.data);
    toast.success("Paramètres enregistrés");
  }

  return (
    <div>
      <h1 className="font-display text-3xl font-extrabold text-[#16324F]">Paramètres</h1>
      <p className="mt-1 text-slate-500">Ajustez les hypothèses utilisées pour vos indicateurs business.</p>

      <section className="mt-8 kf-card p-6 max-w-2xl">
        <div className="flex items-center gap-2">
          <Zap className="w-5 h-5 text-[#19C3B3]"/>
          <h2 className="font-display font-bold text-lg text-[#16324F]">Traitement manuel d&apos;une demande de devis</h2>
        </div>
        <p className="text-sm text-slate-500 mt-1">Cette valeur alimente le KPI principal <b>Temps de traitement des devis estimé économisé</b>.</p>
        <div className="mt-4 grid gap-1.5">
          <Label>Temps moyen nécessaire pour traiter manuellement une demande (minutes)</Label>
          <Input type="number" step="0.5" min="0.5" value={proc} onChange={(e) => setProc(e.target.value)} className="max-w-xs" data-testid="avg-processing"/>
        </div>
        <p className="mt-2 text-xs text-slate-400 italic">Il s&apos;agit d&apos;une estimation : lecture de la demande, rappel client, questions, calcul du prix, envoi du devis.</p>
      </section>

      <section className="mt-6 kf-card p-6 max-w-2xl">
        <div className="flex items-center gap-2">
          <PhoneOff className="w-5 h-5 text-[#16324F]"/>
          <h2 className="font-display font-bold text-lg text-[#16324F]">Durée moyenne d&apos;un appel de devis</h2>
        </div>
        <p className="text-sm text-slate-500 mt-1">Alimente le KPI secondaire <b>Appels / rappels estimés évités</b>.</p>
        <div className="mt-4 grid gap-1.5">
          <Label>Durée moyenne d&apos;un appel de devis (minutes)</Label>
          <Input type="number" step="0.5" min="0.5" value={avg} onChange={(e) => setAvg(e.target.value)} className="max-w-xs" data-testid="avg-call"/>
        </div>
      </section>

      <Button onClick={save} className="mt-6 rounded-full bg-[#16324F] hover:bg-[#0F2438]" data-testid="save-settings"><Save className="w-4 h-4 mr-1"/>Enregistrer</Button>

      <section className="mt-8 kf-card p-6 max-w-2xl">
        <h2 className="font-display font-bold text-lg text-[#16324F]">Compte</h2>
        <div className="mt-4 text-sm space-y-2 text-slate-600">
          <div><span className="text-slate-400">Email :</span> <span className="font-semibold text-[#16324F]">{user?.email}</span></div>
          <div><span className="text-slate-400">Entreprise :</span> <span className="font-semibold text-[#16324F]">{tenant?.business_name}</span></div>
          <div><span className="text-slate-400">Slug public :</span> <span className="font-mono">{tenant?.slug}</span></div>
        </div>
      </section>
    </div>
  );
}
